import { MapPadding } from '@mri/types';

export function getMapPadding(): MapPadding {
  return  {
    left: window.outerWidth > 800 ? 330 : 0,
    bottom: window.outerWidth > 800 ? 40 : 100,
    right: window.outerWidth > 800 ? 20 : 0,
    top: window.outerWidth > 800 ? 84 : 150
  };
}
